import lscache from "lscache";

import {isRecord} from "./is_record";

interface ITimedRecordStorageParams<TEntry> {
    key: string;
    // the lifetime of the whole record, renewed with every update
    ttlMin: number;
    // the stored value of a property while it is still valid, null once it has expired or cannot be read
    readEntry: (value: unknown, now: number) => TEntry | null;
}

/**
 * A propertyId -> entry record in lscache. The whole record expires with its newest entry, older entries are dropped on read.
 */
export const createTimedRecordStorage = <TEntry>({key, ttlMin, readEntry}: ITimedRecordStorageParams<TEntry>) => {
    const read = (now: number): Record<string, TEntry> => {
        const stored: unknown = lscache.get(key);

        if (!isRecord(stored)) {
            return {};
        }

        return Object.entries(stored).reduce<Record<string, TEntry>>((record, [propertyId, value]) => {
            const entry = readEntry(value, now);

            if (entry !== null) {
                record[propertyId] = entry;
            }

            return record;
        }, {});
    };

    // `getEntry` gets the valid entry of the property, if any - the entry it returns is stored and returned
    const update = (propertyId: number, now: number, getEntry: (current: TEntry | undefined) => TEntry): TEntry => {
        const record = read(now);
        const entry = getEntry(record[String(propertyId)]);

        lscache.set(key, {...record, [String(propertyId)]: entry}, ttlMin);

        return entry;
    };

    const clear = () => {
        lscache.remove(key);
    };

    return {read, update, clear};
};
import lscache from "lscache";

import {isRecord} from "./is_record";

interface ITimedRecordStorageParams<TEntry> {
    key: string;
    // the lifetime of the whole record, renewed with every update
    ttlMin: number;
    // the stored value of a property while it is still valid, null once it has expired or cannot be read
    readEntry: (value: unknown, now: number) => TEntry | null;
}

/**
 * A propertyId -> entry record in lscache. The whole record expires with its newest entry, older entries are dropped on read.
 */
export const createTimedRecordStorage = <TEntry>({key, ttlMin, readEntry}: ITimedRecordStorageParams<TEntry>) => {
    const read = (now: number): Record<string, TEntry> => {
        const stored: unknown = lscache.get(key);

        if (!isRecord(stored)) {
            return {};
        }

        return Object.entries(stored).reduce<Record<string, TEntry>>((record, [propertyId, value]) => {
            const entry = readEntry(value, now);

            if (entry !== null) {
                record[propertyId] = entry;
            }

            return record;
        }, {});
    };

    // `getEntry` gets the valid entry of the property, if any - the entry it returns is stored and returned
    const update = (propertyId: number, now: number, getEntry: (current: TEntry | undefined) => TEntry): TEntry => {
        const record = read(now);
        const entry = getEntry(record[String(propertyId)]);

        lscache.set(key, {...record, [String(propertyId)]: entry}, ttlMin);

        return entry;
    };

    const clear = () => {
        lscache.remove(key);
    };

    return {read, update, clear};
};
